<template>
    <el-dialog
            :title="title"
            :visible.sync="showModal"
            width="90%"
            :center="true"
    >
        <el-row v-loading="isLoadingJourneyRequest">
            <el-table
                    v-if="showModal"
                    ref="journeysTable"
                    id="journeys-table"
                    :data="journeys"
                    style="width: 100%"
                    :default-sort = "{prop: 'time_start_moment', order: 'ascending'}"
            >
                <el-table-column
                        type="index"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="Start time"
                        prop="time_start_moment"
                        align="center"
                        sortable>
                    <template slot-scope="scope">
                        {{ scope.row.time_start_moment.format('D MMM, hh:mm a') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="truck_plate"
                        label="Truck"
                        :filters="truckPlates"
                        :filter-method="filterHandler"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="payload_percentage"
                        label="% Full*"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="gvm"
                        label="GVM* (t)"
                        align="center"
                        sortable>
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.method_name" placement="top">
                            <span>{{ scope.row.gvm}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="truck_total_tare"
                        label="Tare (t)"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="payload_weight"
                        label="Payload* (t)"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        v-if="isParceline"
                        prop="tcp_quantity"
                        label="# TCP**"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        v-if="isParceline"
                        prop="available_tcp_quantity"
                        label="Spaces*"
                        align="center"
                        sortable>
                </el-table-column>
                <el-table-column
                        v-if="isParceline"
                        prop="driver_tcp_quantity"
                        label="Driver Spaces***"
                        align="center"
                        sortable>
                </el-table-column>
            </el-table>
            <br>
            <div class="t-mb-10 t-font-bold">
            <el-button
                    type="primary"
                    icon="el-icon-download"
                    @click="exportExcel"
            >
                Export Data
            </el-button>
            <p class="t-float-right">* Predicted ** 380kg per TCP *** Reported by the driver</p>
            </div>
        </el-row>
    </el-dialog>
</template>
<script>
    import { mapGetters, mapState } from 'vuex';
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';

    export default {
        props: {
            user: {
                required: true,
                type: Object,
            }
        },
        data () {
            return {
            }
        },
        methods: {
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            exportExcel () {
                /* generate workbook object from table */
                var wb = XLSX.utils.table_to_book(document.querySelector('#journeys-table'), {raw: true});
                /* get binary string as output */
                var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
                try {
                    const fileName = `capacity_report_from_${this.journeyRequest.placeOriginName}_to_${this.journeyRequest.placeDestinationName}_${this.journeyRequest.start.format('D MMM')}_${this.journeyRequest.end.format('D MMM')}.xlsx`;
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName)
                } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
                return wbout
            },
        },
        watch: {
        },
        computed: {
            ...mapGetters('journeyRequests', {
                journeyRequest: 'getJourneyRequest',
            }),
            ...mapState({
                journeyRequestLoadStatus: state => state.journeyRequests.journeyRequestLoadStatus,
            }),
            title () {
                if (this.journeyRequestLoadStatus === 2) {
                    return `Capacity Report from ${this.journeyRequest.placeOriginName} to ${this.journeyRequest.placeDestinationName} between ${this.journeyRequest.start.format('D MMM')} and ${this.journeyRequest.end.format('D MMM')}`;
                }
                return 'Capacity Report';
            },
            showModal: {
                get() {
                    return this.$store.state.journeyRequests.showJourneyRequestModal
                },
                set(value) {
                    this.$store.dispatch('journeyRequests/updateShowJourneyRequestModal', value)
                }
            },
            journeys () {
                if (this.journeyRequest.journeys) {
                    return this.journeyRequest.journeys;
                } else {
                    return [];
                }
            },
            isLoadingJourneyRequest () {
                return this.journeyRequestLoadStatus === 1;
            },
            truckPlates () {
                if (this.journeyRequest.journeys) {
                    const truckPlates = this.journeyRequest.journeys.map((row) => {
                        return row.truck_plate;
                    }).filter((v, i, a) => a.indexOf(v) === i);
                    return truckPlates.map((plate) => {
                        return {
                            text: plate,
                            value: plate,
                        };
                    });
                } else {
                    return [];
                }
            },
            isParceline () {
                if (this.user.businesses[0]) {
                    return this.user.businesses[0].id === 259;
                }
                return false;
            }
        }
    }
</script>

<style>
</style>